module.exports = __webpack_public_path__ + "img/hospitium-13.979fec2d.jpg";